export enum Reaction {
  HEART1 = '🤍',
  HEART2 = '❤️',
}
